import { render, staticRenderFns } from "./LocalOffers.vue?vue&type=template&id=44869534&scoped=true&"
import script from "./LocalOffers.vue?vue&type=script&lang=js&"
export * from "./LocalOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44869534",
  null
  
)

export default component.exports